<template>
  <v-app-bar app :dense="toolbarDense" class="Subnavigation elevation-0"
             :class="{'mobile-styles': isMobileDevice}"
             height="65"
  >
    <v-app-bar-nav-icon v-if="isMobileDevice" class="no-ripple-background top-header-nav-btn" :ripple="false" @click.stop="toggleNavDrawer"></v-app-bar-nav-icon>
    <v-tabs v-if="navItems && navItems[0].name !== 'Inbox'" :value="activeTab" class="menu-tabs ml-2" :show-arrows="false">
      <template v-for="(menu, i) of menus">
        <v-menu v-if="menu.submenus && menu.submenus.length" :key="i" offset-y>
          <template v-slot:activator="{on, attrs, value}">
            <y-tab class="menu__tab" v-bind="attrs" v-on="on">
              <span class="menu__title">{{ $t(menu.meta.title) }}</span>
              <v-icon right class="menu__icon">
                {{ value ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </y-tab>
          </template>
          <v-list>
            <v-list-item v-for="(submenu, j) of menu.submenus" :key="j" class="menu__submenu-link" link :to="submenu.path">
              <v-list-item-title>
                {{ $t(submenu.meta.title) }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tab v-else :key="i" class="menu__tab" :to="menu.path">
          <span class="menu__title">{{ $t(menu.meta.title) }}</span>
        </v-tab>
      </template>
    </v-tabs>
    <p v-else class="mt-4 font-weight-bold badge-route">
      {{ navItems[0].meta.translatedTitle }}
      <span v-if="getInboxCount && getInboxCount.len !== 0" class="badge-counter ml-1">{{ getInboxCount.len }}</span>
    </p>
    <template v-if="!isMobileDevice">
      <v-spacer class="mx-2" />
      <profile />
    </template>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';
import Profile from '../widget/AppProfile.vue';
import { VTab } from 'vuetify/lib';

/** Tab that does not activate on click, it is a workaround for tab dropdowns */
const YTab = {
  extends: VTab,
  methods: {
    toggle() {
    },
  },
};

export default {
  name: 'TheLayoutToolbar',
  components: {
    Profile,
    YTab,
  },
  data: () => ({
    selectedPath: null,
    model: null,
    activeMenu: null,
  }),
  computed: {
    ...mapGetters(['toolbarDense', 'navbarShow', 'permissionRoutes']),
    childRoutes() {
      const visibleRoutes = this.permissionRoutes.filter((route) => !route.hidden);

      const childRoutes = visibleRoutes.filter((route) => {
        if (route.children.length >= 1) {
          return route.children[0].parentId ? route.children[0].parentId.startsWith(`${this.$route.matched[0].name}`) : false;
        }

        return false;
      });

      if (!childRoutes[0]) {
        const newRoute = { ...this.$route };
        newRoute.meta.translatedTitle = this.$t(newRoute.meta.title);
        return [newRoute];
      }
      return childRoutes[0].children;
    },
    menus() {
      const tree = [];
      const map = {};
      this.childRoutes.forEach((route) => {
        const { groupId } = route.meta;
        const id = route.alias;
        if (!map[id]) {
          map[id] = [];
        }
        if (groupId) {
          if (!map[groupId]) {
            map[groupId] = [];
          }
          map[groupId].push(route);
        } else {
          tree.push({
            ...route,
            submenus: map[id],
          });
        }
      });

      tree.sort((a, b) => a.priority - b.priority);
      tree.forEach((node) => node.submenus.sort((a, b) => a.priority - b.priority));
      return tree;
    },
    navItems() {
      const visibleRoutes = this.permissionRoutes.filter((route) => !route.hidden);

      const childRoutes = visibleRoutes.filter((route) => {
        if (route.children.length >= 1) {
          return route.children[0].parentId ? route.children[0].parentId.startsWith(`${this.$route.matched[0].name}`) : false;
        }

        return false;
      });

      if (!childRoutes[0]) {
        const newRoute = { ...this.$route };
        newRoute.meta.translatedTitle = this.$t(newRoute.meta.title);
        return [newRoute];
      }
      const routes = childRoutes[0].children.map((route) => {
        const newRoute = { ...route };
        newRoute.meta.translatedTitle = this.$t(route.meta.title);
        return newRoute;
      });
      return routes;
    },
    getInboxCount() {
      return this.$store.getters.tasksCount;
    },
    activeTab() {
      const currentPath = this.$route.path;
      return this.menus.findIndex((menu) => menu.path === currentPath || menu.submenus.some((submenu) => submenu.path === currentPath));
    },
  },
  watch: {
    $route() {
      this.selectedPath = `${this.$route.path}`;

      // CLEAR INCOMPLETE FORMS STORE
      this.$store.dispatch('clearIncompleteForms');
    },
  },
  mounted() {
    this.selectedPath = `${this.$route.path}`;
  },
  methods: {
    changeRoute(route) {
      this.$router.push(route);
    },
    toggleNavDrawer() {
      this.$emit('toggle-nav-drawer');
    },
  },
};
</script>

<style lang="scss">
.badge-route {
  cursor: pointer;
}
.badge-counter {
  background-color: $yester-lila-light;
  color: white;
  border-radius: 10px;
  padding: 3px 10px;
  font-size: 13px;
}
.SubnavigationSelect {
  width: auto;
  flex: 0;

  .v-input__icon {
    background: #fff;
    width: 35px;
    height: 35px;
    border-radius: 4px;
    border: 1px solid #E9E9E9;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
  }

  & .v-icon {
    color: $yester-readonly-color !important;
    font-size: 20px;
  }

  .v-input__slot {
    width: 100% !important;
  }

  .v-select__selection--comma {
    overflow: initial;
  }

  input {
    display: none;
  }
}
.Subnavigation {
  border-bottom: 2px solid $yester-light-grey !important;
}

// RESPONSIVENESS
.mobile-styles {
  .badge-route {
      font-weight: 900;
      font-size: 20px;
      display: flex;
  }
  .badge-counter {
    padding: 2px 10px 0px;
    font-size: 10px;
    margin-top: 3px !important;
    height: 20px;
  }
  .SubnavigationSelect {
    z-index: 330 !important;
    padding-right: 92px !important; // to account for actions on mobile
    & .v-icon {
      color: $yester-dark !important;
    }
    .v-select__selections {
      font-size: 20px !important;
    }
  }
  .v-menu__content {
    z-index: 60;
  }
}

.menu__tab {
  text-transform: none;
  font-size: 1rem;
  letter-spacing: 0px;
}

.menu__title {
  color: hsl(0deg 0% 20%);
  font-weight: 400;
}

.menu__tab.v-tab--active .menu__title {
  color: $yester-lila-light !important;
  font-weight: 500;
}

.menu__icon {
  color: $yester-lila-light !important;
}

.menu-tabs {
  max-width: calc(100vw - 500px);
  overflow: auto;

  @media (max-width: 710px) {
    max-width: calc(100vw - 180px);
  }

  .v-slide-group__prev, .v-slide-group__next {
    display: none !important;
  }
}

.menu__submenu-link.v-list-item.v-list-item--active {
  color: $yester-lila-light !important;
  font-weight: 500;
}
</style>
